/**
 * Тексты согласий сайта v2 (01.11, ТЗ 1.17 EMB-019 ч. 1, LAW-003, LAW-004): действующие и выведенные версии pd/ads и новая версия
 * (POST /api/widget-sites/:id/v2/legal). Версия неизменяема: правка — новая версия, прежняя принимается ещё 30 дней. Без текста
 * pd «Работает ли» показывает у сайта «внимание». HTML не принимается (сервер отвергает < и >).
 */
import { useState } from "react";
import { api } from "../../../api/client";
import { BASE, failText } from "./widgetApi";
import { orenTime } from "./widgetFmt";
import type { LegalText } from "./widgetTypes";
import css from "./widget.module.css";

const DOC: Readonly<Record<string, string>> = { pd: "согласие на обработку ПДн", ads: "согласие на рекламу" };
const today = (): string => new Date(Date.now() + 5 * 3_600_000).toISOString().slice(0, 10);

export function WidgetLegal({ id, texts, onSaved }: { id: number; texts: LegalText[]; onSaved: () => void }) {
  const [doc, setDoc] = useState<"pd" | "ads">("pd");
  const [version, setVersion] = useState("");
  const [date, setDate] = useState(today);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const add = async () => {
    setBusy(true); setMsg("");
    try {
      await api(`${BASE}/${id}/v2/legal`, { method: "POST", body: { doc, version: version.trim(), date, text } });
      setMsg(`Версия ${version.trim()} сохранена`); setVersion(""); setText(""); onSaved();
    } catch (e) { setMsg(failText(e, "Не удалось сохранить текст")); }
    setBusy(false);
  };
  return (
    <div className={css.block}>
      <div className={css.sub}>Тексты согласий</div>
      {!texts.length ? <div className={css.warnLine}>Текстов согласий нет — форма заявки без них не готова</div> : null}
      {texts.map((t) => (
        <details key={`${t.doc}-${t.version}`} className={css.row}>
          <summary>{DOC[t.doc] ?? t.doc} · {t.version} от {t.date} · {t.retired_at ? `выведен ${orenTime(`${t.retired_at.replace(" ", "T")}Z`)}` : "действует"}</summary>
          <pre className={css.code}>{t.text}</pre>
        </details>
      ))}
      <div className={css.line}>
        <select className={css.select} value={doc} aria-label="Документ" onChange={(e) => setDoc(e.target.value === "ads" ? "ads" : "pd")}>
          <option value="pd">ПДн</option>
          <option value="ads">реклама</option>
        </select>
        <input className={css.input} value={version} placeholder="версия, например pd-2026-11-01" aria-label="Версия текста" onChange={(e) => setVersion(e.target.value)} />
        <input className={css.input} type="date" value={date} aria-label="Дата текста" onChange={(e) => setDate(e.target.value)} />
      </div>
      <textarea className={css.area} rows={4} value={text} aria-label="Текст согласия" placeholder="Текст согласия без HTML" onChange={(e) => setText(e.target.value)} />
      <div className={css.line}>
        <button type="button" className={css.btn} disabled={busy || !version.trim() || !text.trim()} onClick={() => void add()}>Новая версия текста</button>
        {msg ? <span className={css.toast} role="status">{msg}</span> : null}
      </div>
    </div>
  );
}
